/* Tabbed content section
   Custom element handles activation, keyboard nav, and theme editor events. */

if (!customElements.get('tabbed-content')) {
  class TabbedContent extends HTMLElement {
    constructor() {
      super();
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      this.activateOn = this.dataset.activateOn || 'click';

      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.activate(index));
        tab.addEventListener('keydown', (event) => this.onKeyDown(event, index));

        if (this.activateOn === 'hover') {
          tab.addEventListener('mouseenter', () => {
            if (window.matchMedia('(hover: hover)').matches) this.activate(index, false);
          });
        }
      });
    }

    activate(index, focusTab = true) {
      this.tabs.forEach((tab, i) => {
        const selected = i === index;
        tab.setAttribute('aria-selected', selected ? 'true' : 'false');
        tab.setAttribute('tabindex', selected ? '0' : '-1');
        if (this.panels[i]) this.panels[i].hidden = !selected;
      });

      if (focusTab && this.tabs[index]) this.tabs[index].focus();
    }

    onKeyDown(event, index) {
      const isVertical = this.dataset.layout === 'side' && window.innerWidth > 1024;
      const next = isVertical ? 'ArrowDown' : 'ArrowRight';
      const prev = isVertical ? 'ArrowUp' : 'ArrowLeft';
      let target = null;

      if (event.key === next) target = (index + 1) % this.tabs.length;
      if (event.key === prev) target = (index - 1 + this.tabs.length) % this.tabs.length;
      if (event.key === 'Home') target = 0;
      if (event.key === 'End') target = this.tabs.length - 1;

      if (target !== null) {
        event.preventDefault();
        this.activate(target);
      }
    }

    selectBlock(blockId) {
      const index = this.tabs.findIndex((tab) => tab.id.endsWith(blockId));
      if (index > -1) this.activate(index, false);
    }
  }

  customElements.define('tabbed-content', TabbedContent);
}

/* Theme editor: jump to the tab whose block was selected */
document.addEventListener('shopify:block:select', (event) => {
  const container = event.target.closest('tabbed-content');
  if (!container || typeof container.selectBlock !== 'function') return;
  const blockId = event.detail.blockId || event.target.dataset.blockId || '';
  container.selectBlock(blockId);
});
